import React from "react";
import Svg, { Path, Defs, Stop, LinearGradient } from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function GuidesIcon(props) {
  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8578 2.32929C13.8578 3.174 13.173 3.85877 12.3283 3.85877C11.4836 3.85877 10.7988 3.174 10.7988 2.32929C10.7988 1.48458 11.4836 0.799805 12.3283 0.799805C13.173 0.799805 13.8578 1.48458 13.8578 2.32929ZM6.43438 5.99316C7.27909 5.99316 7.96387 5.30838 7.96387 4.46367C7.96387 3.61896 7.27909 2.93419 6.43438 2.93419C5.58967 2.93419 4.9049 3.61896 4.9049 4.46367C4.9049 5.30838 5.58967 5.99316 6.43438 5.99316ZM18.5966 6.06727C19.3298 5.56073 19.5064 4.54545 18.991 3.79955C18.4757 3.05366 17.4636 2.85962 16.7304 3.36615C15.9973 3.87269 15.8207 4.88797 16.336 5.63387C16.8513 6.37976 17.8634 6.5738 18.5966 6.06727ZM3.92988 11.4894C4.77459 11.4894 5.45936 10.8047 5.45936 9.95995C5.45936 9.11524 4.77459 8.43047 3.92988 8.43047C3.08516 8.43047 2.40039 9.11524 2.40039 9.95995C2.40039 10.8047 3.08516 11.4894 3.92988 11.4894ZM21.6004 10.1897C21.6004 11.0345 20.9156 11.7192 20.0709 11.7192C19.2262 11.7192 18.5414 11.0345 18.5414 10.1897C18.5414 9.34504 19.2262 8.66026 20.0709 8.66026C20.9156 8.66026 21.6004 9.34504 21.6004 10.1897ZM15.0522 13.9496C15.9686 13.1562 16.5483 11.9844 16.5483 10.6772C16.5483 8.2877 14.6113 6.35065 12.2218 6.35065C9.83233 6.35065 7.89527 8.2877 7.89527 10.6772C7.89527 12.1173 8.59887 13.3931 9.68106 14.1795C9.27961 14.5107 8.91239 14.919 8.58942 15.4033C7.60391 16.8812 7.0437 19.0344 7.0437 21.8596V22.819H8.00313H16.8103H17.7587L17.7696 21.8706L16.8103 21.8596C17.7696 21.8706 17.7696 21.8704 17.7696 21.87L17.7696 21.8692L17.7697 21.8671L17.7697 21.8608L17.7698 21.8398C17.7699 21.8221 17.7698 21.7972 17.7696 21.7656C17.7692 21.7024 17.7679 21.6121 17.7648 21.4985C17.7584 21.2717 17.7443 20.951 17.7133 20.5673C17.6516 19.8044 17.5216 18.7713 17.2439 17.7253C16.9693 16.6913 16.5314 15.57 15.8104 14.6902C15.5863 14.4168 15.334 14.1663 15.0522 13.9496ZM15.8141 20.9002C15.8101 20.8427 15.8056 20.7832 15.8006 20.7218C15.7445 20.0266 15.6277 19.1156 15.3892 18.2176C15.1476 17.3075 14.8001 16.4847 14.3263 15.9065C13.8771 15.3584 13.3316 15.0427 12.5916 15.0427C11.7273 15.0427 10.8679 15.4452 10.1859 16.4679C9.5737 17.3859 9.09921 18.822 8.98756 20.9002H15.8141ZM9.81413 10.6772C9.81413 9.34746 10.8921 8.2695 12.2218 8.2695C13.5515 8.2695 14.6295 9.34746 14.6295 10.6772C14.6295 12.0069 13.5515 13.0849 12.2218 13.0849C10.8921 13.0849 9.81413 12.0069 9.81413 10.6772Z"
          fill="url(#paint0_linear_guides)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_guides"
            x1="2.40039"
            y1="5.57505"
            x2="13.8583"
            y2="25.9896"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
